import { Utils } from '@/utils';

export default function (value) {
    if (!value || typeof value !== 'number') return '';
    return '$' + Utils.formatPrice(value);
}
